import React from "react";
import { Bar } from "react-chartjs-2";
import { getBrandPrimaryColor } from "../utils/brandingThemeColor";

const MusicLinkBarChart = ({ topOsData }) => {
  const brandPrimaryColor = getBrandPrimaryColor();

  const barData = {
    labels: topOsData.labels,
    datasets: [
      {
        label: "Operating System: ",
        data: topOsData.data,
        backgroundColor: brandPrimaryColor,
        hoverBackgroundColor: brandPrimaryColor,
        borderColor: brandPrimaryColor,
        hoverBorderColor: brandPrimaryColor,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        display: false,
      },
      tooltip: {
        callbacks: {
          label(context) {
            const usage = context.raw || "";
            return `No Of Views : ${usage}%`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <>
      <div className="chart-wrapper" style={{ width: "100%", margin: "0 auto", height: 300 }}>
        <Bar data={barData} options={options} />
      </div>
    </>
  );
};

export default MusicLinkBarChart;
